module.exports = __webpack_public_path__ + "img/stableDiffusion.b486709e.webp";